import {createSelector} from 'reselect';
import {getSettings} from '../selectors';

export default (deliveryOptionTypeKey, deliveryOptionId, keyType) => createSelector(
  [getSettings],
  (settings) => {
    if (settings[`site_specific_delivery_key_for_${deliveryOptionId}`] && keyType) {
      return settings[`site_specific_delivery_key_for_${deliveryOptionId}`][keyType] || deliveryOptionTypeKey;
    }
    
    return deliveryOptionTypeKey;
  },
);
